module.exports = __webpack_public_path__ + "static/img/WT633-PF_A.8359192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WT633-PF_A.jpg
// module id = 8Jww
// module chunks = 0